export default {
    fields: [
        {
            key: "_selected",
            label: "#",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            fixed: true,
            _style: "width:5%",
        },
        {
            key: "Id",
            label: "Id",
            sorter: false,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "Uuid",
            label: "Uuid",
            sorter: false,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "Status",
            label: "Status",
            sorter: false,
            active: true,
            _active: true,
            filter: true,
            _filter: true,
            _style: "width:10%",
        },
        {
            key: "CreatedAt",
            label: "Created At",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            _style: "width:15%",
        },
        {
            key: "UpdatedAt",
            label: "Updated At",
            sorter: true,
            active: true,
            _active: true,
            filter: false,
            _filter: false,
            _style: "width:15%",
        },

    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: {
        values: [5, 10, 20, 50, 100],
    },
    orderField: "Id",
    dateFieldFilter: "CreatedAt",
    matchResponse: "data.items",
    matchResponseCurrentPage: "data.currentPage",
    matchResponsePages: "data.pages",
}